module.exports = {
  prismicRepo: "dagcoin",
  defaultLanguage: "en-us",
  // langs: ["en-us", "et-ee"],
  langs: ["en-us"],
};
